import { render, staticRenderFns } from "./SleepInfoYJ.vue?vue&type=template&id=2fa12300&scoped=true&"
import script from "./SleepInfoYJ.vue?vue&type=script&lang=js&"
export * from "./SleepInfoYJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa12300",
  null
  
)

export default component.exports